import AgencyAdministrationRouteConstants, { ROOT_URI } from 'AgencyAdministration/AgencyAdministrationRouteConstants';
import Agents from 'AgencyAdministration/components/Agents';
import * as E from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';
import Loading from 'Shared/components/Loading';
import { Scope } from 'Shared/constants/Scope';
import { selectUserScopesEither } from 'Users/selectors/userProfileSelectors';

const AgencyAdministrationRoutes = () => {
  const currentScopesEither = useSelector(selectUserScopesEither);
  const location = useLocation();
  const [route, setRoute] = useState({from: location.pathname, to: location.pathname});

  useEffect(() => {
    setRoute((prev) => ({to: location.pathname, from: prev.to}))
  }, [location])
  const renderAgentsRoute = (currentScopes: Scope[]) => {
    const hasSearchAgentsScope = currentScopes.includes(Scope.SearchAgentUsers);
    const hasAccessToAgencyAdministration = hasSearchAgentsScope;

    return hasAccessToAgencyAdministration ? (
      <Route exact path={AgencyAdministrationRouteConstants.AGENTS} render={() => <Agents />} />
    ) : (
      <Redirect to={'/unauthorized'} />
    );
  };

  return (
    <Route
      path={ROOT_URI}
      render={() =>
        pipe(
          currentScopesEither,
          E.fold(() => <Loading />, renderAgentsRoute)
        )
      }
    />
  );
};

export default AgencyAdministrationRoutes;
